const filterCatgories = () => {
  const filterCategories = document.querySelectorAll('.filter-cat__link--parent') as NodeListOf<HTMLAnchorElement>;

  const getNextElement = (element: HTMLElement) => {
    const nextElement = element.nextElementSibling as HTMLElement;

    if (nextElement && nextElement.classList.contains('filter-cat--child')) {
      nextElement.classList.toggle('filter-cat--show');
      getNextElement(nextElement);
    }
  };

  [...filterCategories].forEach((link) => {
    link.addEventListener('click', (e: Event) => {
      e.preventDefault();
      link.classList.toggle('active');

      const parentElement = link.closest('.filter-cat') as HTMLElement;
      getNextElement(parentElement);
    });
  });
};

export default filterCatgories;
